import SectionHead from './SectionHead';
import { opinionChips, opinionQuotes } from '@/mocks/meihei';

export default function OpinionSection() {
  return (
    <section id="shengyin" className="anchor-target bg-paper py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHead
          eyebrow="舆论现场 · 声量切片"
          title="同一个瓜，评论区里其实站着好几拨人"
          desc="热度从来不只有一种声音。把它拆成几股典型声量，你就能理解评论区为什么总在「吵」，以及各自在吵什么。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {opinionChips.map((c) => (
            <span
              key={c}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-line bg-cream px-3.5 py-1.5 text-[13px] font-medium text-ink/75"
            >
              <i className="ri-chat-smile-3-line text-honey-500" aria-hidden="true"></i>
              {c}
            </span>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {opinionQuotes.map((q) => (
            <figure key={q.side} className="flex flex-col rounded-xl border border-line bg-cream/50 p-5">
              <div className="flex items-center gap-3">
                <span className="grid h-9 w-9 place-items-center rounded-lg bg-ember-50 text-ember-600">
                  <i className={`text-lg ${q.icon}`} aria-hidden="true"></i>
                </span>
                <figcaption className="text-[13px] font-bold text-ink">{q.side}</figcaption>
              </div>
              <blockquote className="mt-4 flex-1 text-[13px] leading-relaxed text-clay">
                <span className="mr-1 font-serif text-ember-400">“</span>
                {q.text}
                <span className="ml-1 font-serif text-ember-400">”</span>
              </blockquote>
            </figure>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-2 text-[12px] leading-relaxed text-clay">
          <i className="ri-lightbulb-flash-line mt-0.5 text-honey-500" aria-hidden="true"></i>
          以上声量切片为概括性描述，用于理解讨论生态，不代表具体立场，也不指向任何个人。看瓜时可以对照识别：自己是哪一拨，又在被哪一拨影响。
        </p>
      </div>
    </section>
  );
}